import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  private baseUrl = environment.apibaseUrl;

  constructor(private http: HttpClient) { }

  getResourceList() {
    return this.http.get(this.baseUrl + '/resources/list');
  }

  ExternalLinkList() {
    return this.http.get(this.baseUrl + '/resources/externalLink/list');
  }

  getCategoryList() {
    return this.http.get(this.baseUrl + '/resources/categorylist');
  }

  getTargetList() {
    return this.http.get(this.baseUrl + '/resources/target');
  }

  saveResource(resourceInfo) {
    // convert Formdata format
    const details = new FormData();
    details.append('documentTitle', resourceInfo.documentTitle);
    details.append('description', resourceInfo.description);
    details.append('resourceFile', resourceInfo.resourceFile);
    details.append('categoryCd', resourceInfo.categoryCd);
    details.append('targetTypeId', resourceInfo.targetTypeId);
    details.append('type', resourceInfo.type);
    details.append('externalLink', resourceInfo.externalLink);
    if (resourceInfo.clinicId) {
      resourceInfo.clinicId.forEach(element => {
        details.append('clinicId', JSON.stringify(element));
      });
    }
    return this.http.post(this.baseUrl + '/resources/save', details);
  }

  editResource(r_id, isResourceFromSystem) {
    return this.http.get(this.baseUrl + '/resources/details/' + r_id + '/' + isResourceFromSystem);
  }

  deleteresources(resourceId, docUrl) {
    return this.http.delete(this.baseUrl + '/resources/delete?resourceId=' + resourceId + '&docUrl=' + docUrl);
  }

  updateResource(rid, resourceInfo) {
    return this.http.put(this.baseUrl + '/resources/update/' + rid, resourceInfo);
  }

  getUrl(fileurl, type) {
    return this.http.get(this.baseUrl + '/resources/url?docurl=' + fileurl + '&type=' + type);
  }

  getFoodandShelterDetails(c_id, agencyTypeId, is_all = false) {
    return this.http.get(this.baseUrl + '/resources/food/shelters?c_id=' + c_id + '&agency_type_id=' + agencyTypeId + '&isAll=' + is_all);
  }

  getCountyEmergencyInfo(c_id, isall = false) {
    return this.http.get(this.baseUrl + '/resources/countyemergencyinfo?c_id=' + c_id + '&isAll=' + isall);
  }

  getagencyTypelist() {
    return this.http.get(this.baseUrl + '/resources/agencytype');
  }

  getResourceType() {
    return this.http.get(this.baseUrl + '/resources/type');
  }

  getInternalResourcecategory() {
    return this.http.get(this.baseUrl + '/resources/category/internal');
  }

  getExternalResourcecategory() {
    return this.http.get(this.baseUrl + '/resources/category/external');
  }

  getLibraryDocsList(participantId) {
    return this.http.get(this.baseUrl + '/resources/library/doclist/' + participantId);
  }

  saveParticipantDocs(resourceInfo) {
    // convert Formdata format
    const details = new FormData();
    details.append('documentTitle', resourceInfo.documentTitle);
    details.append('description', resourceInfo.description);
    details.append('resourceFile', resourceInfo.resourceFile);
    details.append('categoryCd', resourceInfo.categoryCd);
    return this.http.post(this.baseUrl + '/resources/library/save', details);
  }

  updateParticipantDocs(rid, resourceInfo) {
    return this.http.put(this.baseUrl + '/resources/library/update/' + rid, resourceInfo);
  }

  editClientDoc(r_id) {
    return this.http.get(this.baseUrl + '/resources/library/details/' + r_id);
  }

  deleteLibraryResources(resourceId, docUrl) {
    return this.http.delete(this.baseUrl + '/resources/library/delete?docId=' + resourceId + '&docUrl=' + docUrl);
  }

}
